<div class="card side-entity-card" [style.height]="containerHeight">

  <!-- Loading / Saving Overlay -->
  <div class="loading-overlay" *ngIf="loading || isSaving">
    <mat-spinner [diameter]="40"></mat-spinner>
  </div>

  <ng-container *ngIf="editableRecord; else noRecord">
    <!-- Section: Main Form -->
    <div class="form-section">
      <div class="section-header" (click)="data.sections[0].isExpanded = !data.sections[0].isExpanded">
        <span>{{ sectionTitle }}</span>
        <mat-icon>{{ data.sections[0].isExpanded ? 'expand_less' : 'expand_more' }}</mat-icon>
      </div>

      <div class="section-content" *ngIf="data.sections[0].isExpanded">
        <div *ngFor="let field of formFields" class="form-row">
          <label class="form-label">{{ field.label }}</label>
          <mat-form-field appearance="outline" class="form-field">
            <input matInput [(ngModel)]="editableRecord[field.key]">
          </mat-form-field>
        </div>
      </div>

      <div class="form-actions" *ngIf="data.sections[0].isExpanded">
        <hr class="divider" />
        <div class="action-buttons-container">
          <button
            *ngFor="let action of data.sections[0].actions"
            mat-flat-button
            [class]="action.style"
            (click)="handleAction(action.actionId)"
            [disabled]="isSaving">
            {{ action.label }}
          </button>
        </div>
      </div>
    </div>

    <!-- Section: Related Entities (optional) -->
    <div class="form-section" *ngIf="data.sections[1]">
      <div class="section-header" (click)="data.sections[1].isExpanded = !data.sections[1].isExpanded">
        <span>{{ data.sections[1].title }}</span>
        <mat-icon>{{ data.sections[1].isExpanded ? 'expand_less' : 'expand_more' }}</mat-icon>
      </div>
      <div class="section-content" *ngIf="data.sections[1].isExpanded">
        <p>Related entities content placeholder.</p>
      </div>
    </div>
  </ng-container>

  <ng-template #noRecord>
    <div *ngIf="!loading" class="no-record-message">
      Select a record to view its details.
    </div>
  </ng-template>

</div>
